/**
 * Arabic (MSA) dictionary — key tree must exactly match the zh-HK baseline (enforced by i18n:check).
 * Brand names (JKD Coding / Landlink / Bizpulse) and HK$ prices remain untranslated.
 */
import type { Dict } from '../index';

const dict: Dict = {
  // Site meta
  'meta.title': 'JKD Coding | Using No Way as Way — مستشار أعمال بالذكاء الاصطناعي',
  'meta.description': 'يجمع JKD Coding بين فلسفة بروس لي في الجيت كون دو لخدمة المنظمات غير الربحية والمؤسسات الاجتماعية والشركات الصغيرة والمتوسطة من خلال تشخيص التحويل بالذكاء الاصطناعي وتصميم أنظمة النمو وإدارة علاقات العملاء.',

  // Navbar
  'nav.arsenal': 'الترسانة',
  'nav.components': 'المكونات',
  'nav.custom': 'مخصص بالكامل',
  'nav.philosophy': 'الفلسفة',
  'nav.consult': 'استشارة مجانية',

  // Hero
  'hero.kicker': 'Be Water, My Friend',
  'hero.titleA': 'حكمة الماء',
  'hero.titleB': 'حل مشكلات الأعمال بسرعة وحسم',
  'hero.subtitle': 'تصمم JKD Coding أنظمة تحويل بالذكاء الاصطناعي للمنظمات غير الربحية والمؤسسات الاجتماعية والشركات الصغيرة والمتوسطة — دون فرض التكنولوجيا، بل بإيجاد الشكل الأكثر طبيعية لأعمالك: نمو المتبرعين، والاحتفاظ بالعملاء، والإنذار المبكر للتدفق النقدي في مكان واحد.',
  'hero.cta': 'احجز تشخيص التحويل بالذكاء الاصطناعي',
  'hero.approach': 'تعرّف على منهجنا',
  'hero.quote': 'أفرغ عقلك، بلا شكل ولا قيود، مثل الماء.',

  // Services
  'services.tag': 'مجالات عملنا',
  'services.title': 'لا نبيع أدوات، بل نحل المشكلات',
  'services.subtitle': 'كل مشروع يبدأ من عنق الزجاجة في عملك، ثم نقرر الشكل الأنسب لتدخل الذكاء الاصطناعي.',
  'services.m1.eyebrow': '01 / النمو',
  'services.m1.title': 'نمو المتبرعين والعملاء',
  'services.m1.problem': 'الزوار المحتملون يأتون ولا يتحولون، وتكلفة الاستقطاب ترتفع باستمرار.',
  'services.m1.solution': 'تصميم قمع تحويل مدفوع بالذكاء الاصطناعي يحول كل تفاعل إلى بداية علاقة طويلة الأمد.',
  'services.m1.result': 'تحويل أعلى، تكلفة استقطاب أقل',
  'services.m2.eyebrow': '02 / العلاقات',
  'services.m2.title': 'إدارة علاقات العملاء',
  'services.m2.problem': 'متابعات متسربة وردود متأخرة وعملاء يبردون تدريجياً.',
  'services.m2.solution': 'تحويل التواصل الفردي إلى نظام إدارة علاقات قابل للتنبؤ وقابل للتوسع.',
  'services.m2.result': 'تساقط أقل، عودة أعلى',
  'services.m3.eyebrow': '03 / المخاطر',
  'services.m3.title': 'التدفق النقدي والإنذار المبكر للمخاطر',
  'services.m3.problem': 'الديون المعدومة وانتقال العملاء للمنافسين لا تُكتشف إلا بعد فوات الأوان.',
  'services.m3.solution': 'يراقب الذكاء الاصطناعي إشارات السلوك يومياً وينبهك قبل وقوع الخطر.',
  'services.m3.result': 'حماية التدفق النقدي، تعامل مبكر',
  'services.m4.eyebrow': '04 / التبنّي',
  'services.m4.title': 'تبنّي التغيير وكفاءة التشغيل',
  'services.m4.problem': 'النظام يعمل لكن الموظفين لا يرغبون في استخدامه، وتكاليف التدريب ترتفع.',
  'services.m4.solution': 'تصميم مسارات تبنٍ تبدأ من العادات الحالية ليأتي التغيير بشكل طبيعي.',
  'services.m4.result': 'تبنٍّ أعلى، أخطاء أقل',
  'services.m5.eyebrow': '05 / المعرفة',
  'services.m5.problem': 'ينتهي الاجتماع فيتبخر معه الخبرة.',
  'services.problemLabel': 'المشكلة المعتادة',
  'services.solutionLabel': 'منهجنا',
  'services.cta': 'احجز تشخيص أعمال بلا ضغط',

  // Arsenal
  'arsenal.tag': 'READY-TO-DEPLOY',
  'arsenal.title': 'الترسانة',
  'arsenal.subtitle': 'حلول حسب السيناريو، نشر سريع، جاهزة للعمل',
  'arsenal.blindbox.title': 'نظام الصناديق العمياء',
  'arsenal.blindbox.subtitle': 'أداة تسويق موسمية',
  'arsenal.blindbox.desc': 'محرك احتمالات، إدارة جوائز، آليات انتشار اجتماعي، لوحة تحليلات. مثالي لجمع التبرعات للمنظمات غير الربحية وعروض التجارة الإلكترونية وتفاعل المؤثرين.',
  'arsenal.blindbox.f1': 'سمات موسمية (رأس السنة/الكريسماس/منتصف الخريف)',
  'arsenal.blindbox.f2': 'احتمالات مخصصة وآلية ضمان',
  'arsenal.blindbox.f3': 'ميزات فتح القفل بالمشاركة الاجتماعية',
  'arsenal.blindbox.f4': 'لوحة تحليلات كاملة',
  'arsenal.blindbox.f5': 'دعم بالفيديو 30 دقيقة',
  'arsenal.whatsapp.title': 'نظام متابعة تلقائي مخصص عبر WhatsApp',
  'arsenal.whatsapp.subtitle': 'محرك علاقات العملاء',
  'arsenal.whatsapp.desc': 'سير عمل مرن مسبق الإعداد: استعادة السلات المتروكة، تحديثات الطلبات، تأكيد المواعيد، استطلاعات الرضا.',
  'arsenal.whatsapp.f1': 'مكتبة قوالب رسائل',
  'arsenal.whatsapp.f2': 'إعداد روبوت الدردشة',
  'arsenal.whatsapp.f3': 'تكامل أنظمة CRM',
  'arsenal.whatsapp.f4': 'نشر خلال 30 دقيقة',
  'arsenal.whatsapp.f5': 'دعم تقني مستمر',
  'arsenal.promise': '10 دقائق لامتلاك قمع التحويل الخاص بك',
  'arsenal.priceFrom': 'من',

  // Products
  'products.tag': 'NEW RELEASES',
  'products.title': 'أدوات أعمال الذكاء الاصطناعي',
  'products.subtitle': 'مساعدات ذكاء اصطناعي مصممة للشركات الصغيرة والمتوسطة. جرّب العرض التفاعلي الآن.',
  'products.cta': 'جرّب الآن',
  'products.landlink.title': 'Landlink',
  'products.landlink.subtitle': 'مساعد تبنّي العادات بالذكاء الاصطناعي',
  'products.landlink.desc': 'يحل مشكلة "النظام يعمل، لكن الموظفين/العملاء لا يستخدمونه". يقرأ الذكاء الاصطناعي العادات الحالية ويجهز المهام الأكثر استخداماً مسبقاً، ويحوّل الإجراءات المعقدة إلى خطوة واحدة.',
  'products.landlink.f1': 'يقرأ العادات الحالية لتحضير الخطوة التالية',
  'products.landlink.f2': 'ملخص تبنٍّ للإدارة + تذكير WhatsApp يومي',
  'products.landlink.f3': 'نقاط فردية للموظفين وإعادة تنفيذ بنقرة واحدة',
  'products.landlink.f4': 'يحول 5 خطوات إلى خطوة واحدة، فتقل تكاليف التدريب والأخطاء',
  'products.bizpulse.title': 'Bizpulse',
  'products.bizpulse.subtitle': 'مراقب مخاطر العملاء بالذكاء الاصطناعي',
  'products.bizpulse.desc': 'يراقب سلوك العملاء على مدار الساعة، ويكتشف تباطؤ الدفعات وفقدان الاهتمام والانتقال للمنافسين مبكراً. تصرف قبل وقوع الديون المعدومة واحمِ تدفقك النقدي.',
  'products.bizpulse.f1': 'مراجعة يومية لسجلات العملاء بالذكاء الاصطناعي',
  'products.bizpulse.f2': 'كشف تلقائي لتباطؤ الدفعات وبرودة التفاعل',
  'products.bizpulse.f3': 'تنبيهات مخاطر فورية',
  'products.bizpulse.f4': 'لا حاجة لتعلم الذكاء الاصطناعي، جاهز من الصندوق',

  // Components
  'components.tag': 'COMPONENTS LIBRARY',
  'components.title': 'المكونات',
  'components.subtitle': 'قدرات معيارية، اجمعها حسب الحاجة، استقلالية تقنية',
  'components.quote': '"التفكير هو المشكلة، والتنفيذ هو الحل"',
  'components.scroll.name': 'وحدة حركات التمرير',
  'components.scroll.tech': 'Intersection Observer API',
  'components.scroll.desc': 'يدعم 12 تأثيراً مُشغَّلاً بالتمرير — ظهور، انزلاق، تكبير، دوران — مع حدود وزمن تأخير قابلين للضبط',
  'components.i18n.name': 'إطار i18n ثنائي اللغة',
  'components.i18n.tech': 'معاملات URL / كشف المتصفح',
  'components.i18n.desc': 'نظام تبديل محتوى يعتمد على معاملات URL أو الكشف التلقائي للغة المتصفح، مع دعم RTL محفوظ',
  'components.cf-track.name': 'تتبع Cloudflare Workers',
  'components.cf-track.tech': 'Serverless',
  'components.cf-track.desc': 'تتبع سلوك المستخدمين بلا خوادم، مع أحداث مخصصة وتقسيم جماهير وتتبع GA4 متوازٍ',
  'components.cf-webhook.name': 'Cloudflare Workers Webhook',
  'components.cf-webhook.tech': 'HTTP Endpoints',
  'components.cf-webhook.desc': 'نقاط نهاية HTTP موحدة مع تحقق من الطلبات وحدود المعدل وتكامل Zapier/Make',
  'components.og.name': 'حزمة تحسين وسوم OG',
  'components.og.tech': 'Dynamic Meta Tags',
  'components.og.desc': 'توليد وسوم Open Graph ديناميكية مع اختبارات A/B ومحاكاة معاينة وسائل التواصل',
  'components.full.title': 'مكتبة المكونات الكاملة',
  'components.full.desc': 'كل المكونات + دعم ذو أولوية + تحديثات فصلية. مثالي للمشاريع المتوسطة والكبيرة التي تحتاج قدرات تقنية منهجية.',
  'components.full.tag1': 'كل المكونات',
  'components.full.tag2': 'دعم ذو أولوية',
  'components.full.tag3': 'تحديثات فصلية',
  'components.perYear': '/سنة',
  'components.orMonthly': 'أو HK$200 شهرياً',

  // Custom
  'custom.tag': 'CUSTOM DOJO',
  'custom.title': 'المشاريع المخصصة',
  'custom.subtitle': 'قمع تحويل مخصص بالكامل، من الصفر إلى الوحدة، لبناء آلة تحويل فريدة',
  'custom.price': 'عرض سعر المشروع',
  'custom.priceNote': 'حسب النطاق والتعقيد',
  'custom.phase1.week': 'Week 1',
  'custom.phase1.title': 'بحث المنافسين وتحليل الفرص',
  'custom.phase1.desc': 'تحليل منهجي لأفضل 5-10 منافسين: هندسة عكسية للخرائط الحرارية، تقييم الأداء، تداخل كلمات SEO المفتاحية',
  'custom.phase1.deliverable': 'تقرير تحليل فجوات التحويل',
  'custom.phase2.week': 'Week 1–2',
  'custom.phase2.title': 'استراتيجية النص وهندسة المعلومات',
  'custom.phase2.desc': 'مقابلات مستخدمين Jobs-to-be-Done، 10 صيغ للعنوان، استراتيجية الإثبات الاجتماعي، تحسين أفعال CTA',
  'custom.phase2.deliverable': 'دليل استراتيجية النصوص',
  'custom.phase3.week': 'Week 2–4',
  'custom.phase3.title': 'تصميم UI/UX والتحقق من النموذج الأولي',
  'custom.phase3.desc': 'نمط السبرنت المزدوج، نموذج Figma تفاعلي عالي الدقة، اختبار على أجهزة حقيقية',
  'custom.phase3.deliverable': 'نموذج قابل للنقر + مواصفات التصميم',
  'custom.phase4.week': 'Week 4–6',
  'custom.phase4.title': 'التطوير التقني والنشر',
  'custom.phase4.desc': 'بناء طبقة واجهة المستخدم، إعداد منطق JSON، نشر حافة عبر Cloudflare Workers',
  'custom.phase4.deliverable': 'موقع بيئة الإنتاج',
  'custom.phase5.week': 'Week 6–8',
  'custom.phase5.title': 'تتبع البيانات والتحسين',
  'custom.phase5.desc': 'تحليل حركة GA4، خرائط Hotjar الحرارية للسلوك، إطار اختبارات A/B، لوحة تحويل مخصصة',
  'custom.phase5.deliverable': 'تقرير مراقبة البيانات',
  'custom.cta': 'احجز استشارة مجانية',
  'custom.ctaNote': 'بلا التزام، نفهم احتياجات عملك أولاً',

  // Philosophy
  'philosophy.tag': 'PHILOSOPHY',
  'philosophy.title': 'الفلسفة',
  'philosophy.subtitle': 'منهجية vibe-coding، علمك الصيد بدل أن تعطيك السمكة',
  'philosophy.pillar1.title': 'فلسفة الجيت كون دو',
  'philosophy.pillar1.desc': 'فلسفة بروس لي «استخدام لا طريق كطريق» تلتقي التطوير السريع الحديث، واستكشاف كيف تتحول حكمة الفنون القتالية إلى عقلية تطوير رقمية',
  'philosophy.pillar2.title': 'إطار منهجية RPE',
  'philosophy.pillar2.desc': 'دليل كامل للنمذجة السريعة والتنفيذ: مقابلات الاحتياجات، اختيار أدوات النماذج، اختبار المستخدمين، إيقاع التكرار',
  'philosophy.pillar3.title': 'مراجعات الأدوات والتطبيق',
  'philosophy.pillar3.desc': 'مراجعات معمقة لمنصات Bubble وWebflow وFramer وغيرها من منصات لا-كود/قليل-كود، دون تجميل، لبناء مصداقية موضوعية',

  // FAQ
  'faq.tag': 'FAQ',
  'faq.title': 'الأسئلة الشائعة',
  'faq.subtitle': 'أجوبة مباشرة عن طريقة عمل JKD Coding',
  'faq.q1': 'ما أنواع المنظمات التي تخدموها؟',
  'faq.a1': 'نخدم المنظمات غير الربحية والمؤسسات الاجتماعية والشركات الصغيرة والمتوسطة حول العالم. سواء كان الأمر نمواً في المتبرعين أو إدارة علاقات العملاء أو الإنذار المبكر للتدفق النقدي، نبدأ دائماً من مشكلة عملك الحقيقية.',
  'faq.q2': 'ما هو تشخيص التحويل بالذكاء الاصطناعي وماذا يحدث فيه؟',
  'faq.a2': 'إنه حوار استشاري فردي لمدة 30 دقيقة. نوضح أكبر عنق زجاجة في عملك ونجد أكثر نقاط دخول طبيعية للذكاء الاصطناعي؛ وبعدها تتلقى توصيات تحسين ملموسة، دون أي ضغط بيعي.',
  'faq.q3': 'كيف تُحسب الأسعار؟',
  'faq.a3': 'الحلول الجاهزة تبدأ من HK$800 (نظام الصناديق العمياء) وHK$1,500 (المتابعة التلقائية عبر WhatsApp)؛ المكونات الفردية HK$300–800، والمكتبة الكاملة HK$2,000/سنة؛ المشاريع المخصصة تُسعّر حسب النطاق، عادة HK$15,000–50,000.',
  'faq.q4': 'متى يمكننا الانطلاق؟',
  'faq.a4': 'الحلول الجاهزة تنشر خلال 30 دقيقة؛ مكتبة المكونات تُسلّم خلال أيام؛ المشاريع المخصصة تمر بخمس مراحل وتنطلق عادة خلال 6–8 أسابيع.',
  'faq.q5': 'لسنا تقنيين — هل يمكننا العمل معكم؟',
  'faq.a5': 'بالتأكيد. نتولى التفاصيل التقنية وأنت فقط تصف أهداف عملك. جميع الاستفسارات تُرد خلال 24 ساعة، ويتبع ذلك دعم تقني مستمر بعد اعتماد الخطة.',
  'faq.author': 'الكاتب: فريق JKD Coding',
  'faq.updated': 'آخر تحديث سبتمبر 2026',

  // Contact
  'contact.tag': 'GET IN TOUCH',
  'contact.title': 'ابدأ رحلتك',
  'contact.subtitle': '"الحياة... أشبه بالتغوط، أحياناً لينة وأحياناً صلبة؛ أحياناً سلسة وأحياناً لا!"',
  'contact.form.title': 'أرسل رسالة',
  'contact.form.name': 'الاسم',
  'contact.form.namePlaceholder': 'اسمك',
  'contact.form.email': 'البريد الإلكتروني',
  'contact.form.emailPlaceholder': 'your@email.com',
  'contact.form.business': 'نوع النشاط',
  'contact.form.businessPlaceholder': 'اختر نوع نشاطك',
  'contact.form.businessNgo': 'منظمة غير ربحية / مؤسسة اجتماعية',
  'contact.form.businessSme': 'شركة صغيرة ومتوسطة',
  'contact.form.businessPersonal': 'علامة شخصية',
  'contact.form.businessOther': 'أخرى',
  'contact.form.message': 'الرسالة',
  'contact.form.messagePlaceholder': 'صف احتياجاتك أو أسئلتك بإيجاز...',
  'contact.form.submit': 'أرسل الرسالة',
  'contact.form.processing': 'جارٍ المعالجة...',
  'contact.form.waNote': 'الخطوة التالية هي التحقق من هويتك عبر WhatsApp — تأكد من إمكانية استخدام WhatsApp.',
  'contact.verify.title': 'تحقق من WhatsApp الخاص بك',
  'contact.verify.desc': 'اضغط الزر أدناه لفتح WhatsApp وإرسال رسالة التحقق لإكمال الإرسال.',
  'contact.verify.codeLabel': 'رمز التحقق الخاص بك / Your Verification Code',
  'contact.verify.openWa': 'افتح WhatsApp للتحقق / Open WhatsApp',
  'contact.verify.prefillNote': 'ستُعبأ رسالة التحقق مسبقاً / Verification message will be pre-filled',
  'contact.verify.back': '← رجوع / Go Back',
  'contact.success.title': 'تم التحقق بنجاح!',
  'contact.success.desc': 'استلمنا استفسارك وسنرد خلال 24 ساعة.',
  'contact.quick.title': 'تواصل سريع',
  'contact.quick.whatsapp': 'استشارة عبر WhatsApp',
  'contact.quick.whatsappDesc': 'رد فوري، احجز استشارة مجانية',
  'contact.quick.response': 'وعد الرد السريع',
  'contact.quick.responseDesc': 'جميع الاستفسارات تُرد خلال 24 ساعة',
  'contact.promise': '"سواء كنت منظمة غير ربحية أو مؤسسة اجتماعية أو شركة صغيرة ومتوسطة، سنجد الطريقة الأكثر مباشرة لمساعدتك في الوصول إلى الحل الأفضل. لا تقلق من التفاصيل التقنية، فقط أخبرنا بأهداف عملك."',
  'contact.promiseAuthor': '— فريق JKD Coding',
  'contact.alertFail': 'فشل الإرسال. حاول مجدداً أو تواصل معنا مباشرة عبر WhatsApp.',
  'contact.waPrefill': 'مرحباً! أود معرفة المزيد عن خدمات JKD Coding.',

  // Footer
  'footer.desc': 'نجمع بين فلسفة بروس لي في الجيت كون دو و«استخدام لا طريق كطريق» كفكرة ابتكار أساسية، لبناء قمع تحويل للمنظمات غير الربحية والمؤسسات الاجتماعية والشركات الصغيرة والمتوسطة.',
  'footer.products': 'المنتجات',
  'footer.content': 'المحتوى',
  'footer.about': 'عن',
  'footer.aboutUs': 'من نحن',
  'footer.contact': 'اتصل بنا',
  'footer.faq': 'الأسئلة الشائعة',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.terms': 'شروط الخدمة',
  'footer.rights': 'All rights reserved.',
  // Diagnostic share card (P0 referral entry)
  'share.title': 'رشّح لصديق',
  'share.desc': 'تعرف على شركة تعاني من مشاكل تبنّي الأنظمة؟ شاركها التشخيص المجاني.',
  'share.copy': 'نسخ الرابط',
  'share.copied': 'تم النسخ!',
  'share.whatsapp': 'شارك عبر WhatsApp',
  'share.more': 'طرق مشاركة أخرى',
  'share.prefill': 'وصاني صديق أن أجرّب تشخيص التحويل المجاني بالذكاء الاصطناعي من JKD Coding (30 دقيقة، دون أي ضغط بيعي):',

  // Diagnostic page (/diagnosis)
  'diag.tag': 'مكالمة استراتيجية 30 دقيقة',
  'diag.title': 'تشخيص التحويل بالذكاء الاصطناعي',
  'diag.subtitle': '30 دقيقة لتوضيح عنق الزجاجة في عملك وإيجاد أنسب نقاط دخول للذكاء الاصطناعي.',
  'diag.back': 'العودة للرئيسية',
  'diag.step1Title': 'أخبرنا عن وضعك',
  'diag.step1Desc': 'بعد الإرسال، سيتواصل معك مستشارنا خلال يوم عمل واحد.',
  'diag.name': 'الاسم *',
  'diag.organization': 'المنظمة *',
  'diag.role': 'المنصب *',
  'diag.email': 'البريد الإلكتروني *',
  'diag.businessType': 'نوع النشاط *',
  'diag.businessPlaceholder': 'اختر',
  'diag.ngo': 'منظمة غير ربحية / مؤسسة اجتماعية',
  'diag.sme': 'شركة صغيرة ومتوسطة',
  'diag.personal': 'علامة شخصية',
  'diag.other': 'أخرى',
  'diag.challenge': 'ما أكبر تحدي تحويل تواجهه؟ *',
  'diag.challengePlaceholder': 'اختر',
  'diag.challenge1': 'الزوار يأتون لكن لا يتحولون',
  'diag.challenge2': 'متابعات متسربة أو ردود بطيئة جداً',
  'diag.challenge3': 'ديون معدومة أو مخاطر فقدان يصعب التنبؤ بها',
  'diag.challenge4': 'الفريق يرفض استخدام النظام الجديد',
  'diag.challenge5': 'محتوى غير كافٍ للتواصل المستمر',
  'diag.goals': 'هدف العمل الذي تريد حله أولاً *',
  'diag.goalsPlaceholder': 'صف النتيجة التي تريدها بإيجاز، مثال: رفع نسبة إتمام التبرعات 30%',
  'diag.budget': 'نطاق الميزانية المقبولة (اختياري)',
  'diag.budgetPlaceholder': 'اختر',
  'diag.budget1': 'HK$8,000 – 20,000',
  'diag.budget2': 'HK$20,000 – 50,000',
  'diag.budget3': 'HK$50,000 – 150,000',
  'diag.budget4': 'HK$150,000+',
  'diag.privacy': 'معلوماتك تُستخدم فقط لترتيب هذا الحوار ولن تُباع لأي جهة.',
  'diag.submit': 'احجز تشخيصي الخاص',
  'diag.submitting': 'جارٍ المعالجة...',
  'diag.verifyTitle': 'تحقق من WhatsApp الخاص بك',
  'diag.verifyDesc': 'اضغط الزر أدناه لفتح WhatsApp وإرسال رسالة التحقق لإكمال الحجز.',
  'diag.code': 'رمز التحقق الخاص بك',
  'diag.openWhatsApp': 'افتح WhatsApp للتحقق',
  'diag.prefilled': 'ستُعبأ رسالة التحقق مسبقاً',
  'diag.goBack': 'رجوع',
  'diag.successTitle': 'تم التحقق بنجاح!',
  'diag.successDesc': 'استلمنا طلب التشخيص وسنرد خلال 24 ساعة.',
  'diag.alertFail': 'فشل الإرسال. حاول مجدداً.',
  'diag.msgOrg': 'المنظمة',
  'diag.msgRole': 'المنصب',
  'diag.msgChallenge': 'أكبر تحدٍ',
  'diag.msgGoals': 'الهدف المطلوب حله أولاً',
  'diag.msgBudget': 'نطاق الميزانية',
  'diag.msgUnfilled': 'غير محدد',

  // Landlink (/landlink)
  'landlink.brandName': 'Landlink',
  'landlink.backAria': 'العودة للرئيسية',
  'landlink.brandAria': 'Landlink',
  'landlink.zero.kicker': 'مساعد تبنّي العادات بالذكاء الاصطناعي',
  'landlink.zero.titleA': 'النظام يعمل،',
  'landlink.zero.titleB': 'لكن الموظفين/العملاء لا يستخدمونه؟',
  'landlink.zero.body': 'يقرأ Landlink الإجراءات الحالية ويجهز المهام الأكثر استخداماً مسبقاً،',
  'landlink.zero.bodyStrong': 'يحول خمس خطوات إلى خطوة واحدة.',
  'landlink.zero.cta': 'شاهد أين تكمن المقاومة',
  'landlink.zero.dashLabel': 'ADOPTION RATE',
  'landlink.one.kicker': 'الذكاء الاصطناعي يحلل مقاومات التبنّي لديك',
  'landlink.one.title': 'التقنية تعمل؛ العادات ليست كذلك دائماً.',
  'landlink.one.body': 'اضغط الإشارات الثلاث لترى الأسباب الحقيقية لتجنب الموظفين أو العملاء النظام.',
  'landlink.one.closeAria': 'إغلاق',
  'landlink.one.continueNext': 'تابع إلى الإشارة التالية →',
  'landlink.one.continueDone': 'شاهد كيف يتولى الذكاء الاصطناعي المهمة →',
  'landlink.one.progressPre': 'الإشارات المعروضة:',
  'landlink.one.progressPost': '',
  'landlink.one.f1.eyebrow': 'مقاومة: الألفة',
  'landlink.one.f1.title': 'الطريقة القديمة بلا تكلفة تفكير',
  'landlink.one.f1.text': 'الورق والقلم أصبحا غريزة؛ حتى خطوة إضافية واحدة في نظام جديد تُترك في أكثر اللحظات انشغالاً. المشكلة ليست في الميزات بل في تكلفة تغيير العادة.',
  'landlink.one.f2.eyebrow': 'مقاومة: الخوف من الخطأ',
  'landlink.one.f2.title': 'موظفو الخطوط الأمامية يخافون الضغط الخاطئ',
  'landlink.one.f2.text': 'عندما تكون نتيجة العملية غير واضحة، يختار الموظفون الطريق القديم الأكثر أماناً. ما يحتاجون إليه ليس دورة تدريبية أخرى بل تغذية راجعة فورية ومؤكدة.',
  'landlink.one.f3.eyebrow': 'مقاومة: غياب العائد',
  'landlink.one.f3.title': 'التغيير لا علاقة لي به',
  'landlink.one.f3.text': 'الشركة تحقق الكفاءة، بينما لا يشعر موظفو الخطوط الأمامية إلا بالمشقة. يجب أن يصل العائد إلى الفرد قبل أن يتحول التبنّي من أمر إلى اختيار.',
  'landlink.two.kicker': 'وكلاء الذكاء الاصطناعي ليسوا مفهوماً نظرياً — شاهد واحداً يعمل فعلاً',
  'landlink.two.titlePre': '5 خطوات في ',
  'landlink.two.titleHighlight': 'خطوة واحدة',
  'landlink.two.titlePost': '.',
  'landlink.two.body': 'نفس الطلب بطريقتين. الفجوة هي الخيار الذي يواجهه الموظفون والعملاء يومياً.',
  'landlink.two.startHint': 'اضغط ابدأ لترى الذكاء الاصطناعي يضغط خمس خطوات في حركة واحدة باستخدام العادات الحالية.',
  'landlink.two.startCta': 'ابدأ المقارنة',
  'landlink.two.classicLabel': 'الطريقة التقليدية',
  'landlink.two.classicStepsLabel': '5 خطوات',
  'landlink.two.step1': 'افتح نظام الطلبات',
  'landlink.two.step2': 'اختر كل صنف',
  'landlink.two.step3': 'أدخل الكمية والمواصفات',
  'landlink.two.step4': 'راجع تفاصيل التوصيل',
  'landlink.two.step5': 'أكّد وأرسل',
  'landlink.two.orderLabel': 'طلب نموذجي',
  'landlink.two.orderItem': '🥬 خس × 2',
  'landlink.two.aiLabel': 'طريقة الذكاء الاصطناعي',
  'landlink.two.aiStepsLabel': 'حركة واحدة',
  'landlink.two.aiReadyLabel': 'الذكاء الاصطناعي جهّزها',
  'landlink.two.aiOrder': '🥬 خس × 2 · إلى فرع سنترال · هذا الصباح',
  'landlink.two.evidenceIntro': 'بناءً على العادات السابقة',
  'landlink.two.ev1.label': 'آخر 4 طلبات',
  'landlink.two.ev1.value': 'كلها خس × 2',
  'landlink.two.ev2.label': 'موقع التوصيل المعتاد',
  'landlink.two.ev2.value': 'فرع سنترال · 9 مرات',
  'landlink.two.ev3.label': 'عادة يوم الاثنين',
  'landlink.two.ev3.value': 'عادةً يعيد التوريد الساعة 10 صباحاً',
  'landlink.two.confirm': 'نفس الطلب · تأكيد وإرسال',
  'landlink.two.confirmed': 'تم التأكيد',
  'landlink.two.aiNote': 'يستخدم الذكاء الاصطناعي سجلات الشركة المصرّح بها فقط — لكل اقتراح مصدر.',
  'landlink.three.titlePre': 'لا نطلب من الناس التغيير —',
  'landlink.three.titleMid': '',
  'landlink.three.titleHighlight': 'بل نجعله جديراً بالاهتمام',
  'landlink.three.titlePost': '.',
  'landlink.three.body': 'الدافع والقدرة والتذكير كلها ضرورية. يقلل Landlink المقاومة ويرفع العائد للإدارة والخطوط الأمامية معاً.',
  'landlink.three.cta': 'ابدأ الحوار',
  'landlink.three.card1.title': 'طبقة الإدارة | قيادة من الأعلى',
  'landlink.three.card1.copy': 'يمنح المديرين رؤية واضحة لتقدم التبنّي وأساساً للتذكير الاستباقي اليومي.',
  'landlink.three.card2.title': 'طبقة الخطوط الأمامية | الحوافز تصل للفرد',
  'landlink.three.card2.copy': 'يجعل النظام الجديد أسرع وأسهل ويستحق الفتح كل يوم.',
  'landlink.four.kicker': 'اجعل النظام ينجح فعلاً',
  'landlink.four.titlePre': 'النظام التالي الذي سيتغير',
  'landlink.four.titleMid': 'قد يكون',
  'landlink.four.titleHighlight': 'نظامك',
  'landlink.four.titlePost': '.',
  'landlink.four.body': 'أخبرنا بالنظام الذي تطرحه وسنجد الخطوة الأجدى البدء بها.',
  'landlink.four.ctaLoading': 'جارٍ توصيلك بمستشار…',
  'landlink.four.cta': 'اعرف المزيد عبر WhatsApp',
  'landlink.four.note': 'لا حاجة لخبرة تقنية · سنشرح لك خطوة بخطوة',
  'landlink.four.waPrefill': 'مرحباً، أود معرفة المزيد عن Landlink، مساعد تبنّي العادات بالذكاء الاصطناعي.',

  // Bizpulse (/bizpulse)
  'bizpulse.brandName': 'Bizpulse',
  'bizpulse.backAria': 'العودة للرئيسية',
  'bizpulse.title': 'وظّف مسؤول مخاطر بالذكاء الاصطناعي لا يكلّ أبداً',
  'bizpulse.kicker': 'مراقبة مخاطر العملاء بالذكاء الاصطناعي',
  'bizpulse.heroBody': 'يراقب كل عميل نيابة عنك، على مدار الساعة.',
  'bizpulse.heroStrong': 'تأخر دفعات أو فقدان عملاء أو انتقالهم للمنافسين — الذكاء الاصطناعي يخبرك أولاً.',
  'bizpulse.heroCta': 'شاهد كيف يراقب الذكاء الاصطناعي عملائي',
  'bizpulse.scanLabel': 'الذكاء الاصطناعي يمسح عملائك الآن',
  'bizpulse.one.title': 'الذكاء الاصطناعي يرى الخطر قبل وقوعه.',
  'bizpulse.one.body': 'اضغط الإنذارات الحمراء الثلاث لترى ما يمكن للذكاء الاصطناعي اكتشافه مبكراً.',
  'bizpulse.one.closeAria': 'إغلاق',
  'bizpulse.one.continueNext': 'تابع إلى الإنذار التالي →',
  'bizpulse.one.continueDone': 'شاهد كيف يعمل مسؤول المخاطر AI →',
  'bizpulse.one.progressPre': 'الإنذارات المعروضة:',
  'bizpulse.one.progressPost': '',
  'bizpulse.one.s1.title': 'احتمال تأخر سداد',
  'bizpulse.one.s1.tag': 'لاحظ الذكاء الاصطناعي: الدفعات بدأت تتباطأ',
  'bizpulse.one.s1.detail': 'مواعيد سداد هذا العميل تتأخر باستمرار. ينبهك الذكاء الاصطناعي قبل أن تصبح ديوناً معدومة لتلاحقها مبكراً وتحمي تدفقك النقدي.',
  'bizpulse.one.s2.title': 'احتمال فقدان العميل',
  'bizpulse.one.s2.tag': 'لاحظ الذكاء الاصطناعي: العميل يبرد',
  'bizpulse.one.s2.detail': 'استفسارات أقل وردود أبطأ وتفاعل متناقص. يراقب الذكاء الاصطناعي يومياً لتتمكن من الاحتفاظ بالعميل قبل رحيله.',
  'bizpulse.one.s3.title': 'احتمال الانتقال للمنافس',
  'bizpulse.one.s3.tag': 'لاحظ الذكاء الاصطناعي: تغيرت عادات الطلب',
  'bizpulse.one.s3.detail': 'تكرار الطلبات وكمياتها بدأت تخرج عن المألوف. يكشف الذكاء الاصطناعي هذه التحولات الدقيقة لتستغل آخر نافذة متابعة.',
  'bizpulse.two.step1.title': 'ربط السجلات',
  'bizpulse.two.step1.copy': 'مكان واحد لبيانات العملاء',
  'bizpulse.two.step2.title': 'مسح يومي بالذكاء الاصطناعي',
  'bizpulse.two.step2.copy': 'اكتشاف السلوك غير المعتاد',
  'bizpulse.two.step3.title': 'تنبيهات فورية',
  'bizpulse.two.step3.copy': 'يخبرك بالخطر مباشرة',
  'bizpulse.two.step4.title': 'متابعة مبكرة',
  'bizpulse.two.step4.copy': 'حماية العمل والنقد',
  'bizpulse.two.finalSmall': 'مسؤول المخاطر AI الخاص بك',
  'bizpulse.two.titlePre': 'لا حاجة لتعلم الذكاء الاصطناعي.',
  'bizpulse.two.titleHighlight': 'الذكاء الاصطناعي يراقب عملاءك تلقائياً.',
  'bizpulse.two.finalBody': 'يمسح يومياً ولا يكلّ؛ وبمجرد ظهور خطر تُبلَّغ فوراً.',
  'bizpulse.two.ctaLoading': 'جارٍ توصيلك بمستشار…',
  'bizpulse.two.cta': 'اعرف المزيد عبر WhatsApp',
  'bizpulse.two.note': 'لا حاجة لخبرة تقنية · سنشرح لك خطوة بخطوة',
  'bizpulse.two.waPrefill': 'مرحباً، أود معرفة كيفية توظيف مسؤول مخاطر بالذكاء الاصطناعي لمراقبة مخاطر عملائي.',

  // Promo (/promo)
  'promo.kicker': 'العقارات × أتمتة وسائل التواصل',
  'promo.titlePre': 'تحديث العقارات، النشر، تتبع البيانات —',
  'promo.titleHighlight': 'نظام واحد ينجز كل شيء.',
  'promo.heroLead': 'بمجرد إدخال عقار جديد يتحول إلى منشور FB احترافي خلال 10 ثوانٍ — علامة مائية تلقائية ضد السرقة، روابط قصيرة متتبعة، وإحصاءات تلقائية لأكثر العقارات طلباً.',
  'promo.heroBold': '"من صور إلى فيديو"',
  'promo.heroTail': ' — أقل جهد، أفضل تجربة عميل.',
  'promo.videoCaption': '▲ عرض حي: بيانات العقار → فيديو احترافي بنقرة واحدة (موسيقى وترجمة وبطاقة تواصل وQR تلقائية)',
  'promo.ctaDemo': 'احجز عرضاً عبر WhatsApp',
  'promo.ctaTry': 'جرّبه عبر الإنترنت',
  'promo.waPrefill': 'أود معرفة المزيد عن حل مزامنة العقارات مع وسائل التواصل',
  'promo.painTitle': 'ثلاثة أمور يواجهها كل وسيط عقاري يومياً',
  'promo.pain1.t': 'العقارات تتغير يومياً',
  'promo.pain1.d': 'جديد، مؤجَّر، مباع — بعد تحديث الموقع عليك النشر يدوياً في وسائل التواصل أيضاً، ومضايقة في الاتجاهين',
  'promo.pain2.t': 'الصور تُسرق فور نشرها',
  'promo.pain2.d': 'صور العقارات التي التقطت بشق الأنصة تُحمَّل وتُستخدم في لمح البصر — حتى تعديلات الذكاء الاصطناعي لا تمنع ذلك',
  'promo.pain3.t': 'أموال الإعلانات تذهب هباءً',
  'promo.pain3.d': 'تُنشر المنشورات دون معرفة أي عقار يلقى مشاهدة أو كم نقرة — بلا بيانات لا يوجد اتجاه',
  'promo.stepsTitlePre': 'من العقار إلى المنشور —',
  'promo.stepsTitleHighlight': '3 خطوات، 10 ثوانٍ',
  'promo.stepsNote': 'لقطات شاشة حقيقية للنظام أدناه، وليست تصورات',
  'promo.screenshotAlt': 'عرض حي للنظام: منطقة الترويج الاجتماعي',
  'promo.screenshotCaption': '▲ لوحة التحكم مباشرة: اختر الصور → نص يُولّد تلقائياً (قابل للتعديل) → نشر بنقرة واحدة مباشرة إلى FB',
  'promo.step1.t': 'اختر الصور',
  'promo.step1.d': 'اختر صور العقار، ويضيف النظام علامة مائية قطرية مركزية بالعلامة التجارية — يصعب إزالتها حتى بتعديل الذكاء الاصطناعي',
  'promo.step2.t': 'انشر',
  'promo.step2.d': 'نص المنشور يُولّد تلقائياً: العنوان، سعر البيع/الإيجار، العنوان، الرابط المختصر — اضغط "نسخ النص" للتعديل',
  'promo.step3.t': 'شاهد الأرقام',
  'promo.step3.d': 'كل منشور يأتي بتتبع مدمج: نقرات FB ومشاهدات صفحة العقار — كل ذلك مرئي في لوحة التحكم',
  'promo.magicBadge': 'الميزة الأقوى',
  'promo.magicTitlePre': 'بضع صور تتحول إلى',
  'promo.magicTitleHighlight': 'فيديو عقاري احترافي.',
  'promo.magicBodyLead': 'ارفع صور العقار وينشئ النظام فيديو 1080p: موسيقى تلقائية وترجمة ديناميكية (عنوان/سعر/عنوان) وشعار العلامة، ',
  'promo.magicBodyBold': 'بلا خبرة مونتاج وبلا موظفين',
  'promo.magicBodyTail': '. منشورات الفيديو تصل إلى جمهور أوسع بكثير من منشورات الصور على FB — عقار واحد، وطريقتان للعب.',
  'promo.bullet1': 'عرض دوار للصور + حركة Ken Burns',
  'promo.bullet2': 'أربعة أنماط موسيقية، تبديل بنقرة',
  'promo.bullet3': 'مربع 1:1 / عمودي 9:16، يعمل على FB وIG',
  'promo.compareTitle': 'لنحسب الحساب',
  'promo.compare.col1': 'توظيف / يدوياً',
  'promo.compare.col2': 'هذا النظام',
  'promo.compare.r1.c0': 'منشور واحد',
  'promo.compare.r1.c1': '30–60 دقيقة',
  'promo.compare.r1.c2': '10 ثوانٍ',
  'promo.compare.r2.c0': 'فيديو عقاري',
  'promo.compare.r2.c1': 'نصف يوم + أجور مونتاج',
  'promo.compare.r2.c2': '1–2 دقيقة، يُولّد تلقائياً',
  'promo.compare.r3.c0': 'حماية الصور',
  'promo.compare.r3.c1': 'لا شيء',
  'promo.compare.r3.c2': 'علامة مائية بمستوى AI مدمجة',
  'promo.compare.r4.c0': 'تحليلات كل عقار',
  'promo.compare.r4.c1': 'لا شيء / أدوات منفصلة',
  'promo.compare.r4.c2': 'مدمجة، جاهزة في اللوحة',
  'promo.compare.r5.c0': 'التكلفة الشهرية',
  'promo.compare.r5.c1': '$8,000–15,000',
  'promo.compare.r5.c2': 'رسم شهري واحد في المتناول',
  'promo.compareNote': '* النظام يعمل فعلياً اليوم لدى وسطاء عقاريين',
  'promo.ctaTitlePre': 'العقار الجديد القادم،',
  'promo.ctaTitleHighlight': 'سيكون على FB بعد 10 ثوانٍ.',
  'promo.ctaSub': 'احجز عرضاً تجريبياً عبر الإنترنت لمدة 15 دقيقة وجرّبه بعقارك أنت.',
  'promo.ctaNote': 'سحابي · بياناتك ملكك · بلا عقود طويلة · دعم مخصص',
  'promo.footer': 'JKD Coding · Using No Way as Way',
  // ===== Distill معمل تقطير المعرفة (/distill/) =====
  'distill.meta.title': 'معمل تقطير المعرفة — نحوّل خبرة المؤسسة إلى قواعد تعمل فعلاً | JKD Coding',
  'distill.meta.description': 'معمل تقطير المعرفة من JKD Coding يقدّم خدمة استخلاص المعرفة للشركات الكبرى والمتوسطة والصغيرة: نحوّل الخبرة المتناثرة في الاجتماعات والرسائل وعقول الزملاء المخضرمين إلى قواعد قابلة للتنفيذ وإعادة الاستخدام يمكن لموظفي الذكاء الاصطناعي العمل بها. لحظة انتهاء الاجتماع، تكون القواعد على الحائط.',
  'distill.hero.kicker': 'Be Water, My Friend',
  'distill.hero.title': 'المعرفة كالماء — تتخذ شكلها حين تُجمَع',
  'distill.hero.tagline': 'معمل تقطير المعرفة',
  'distill.hero.lead': 'تقدّم JKD Coding خدمة استخلاص المعرفة للشركات الكبرى والمتوسطة والصغيرة: نقطّر الخبرة المتناثرة في الاجتماعات والرسائل وعقول الزملاء المخضرمين إلى قواعد قابلة للتنفيذ وإعادة الاستخدام يعمل بها موظفو الذكاء الاصطناعي — لحظة انتهاء الاجتماع، تكون القواعد على الحائط.',
  'distill.hero.cta1': 'احجز تشخيصاً لمدة ٣٠ دقيقة',
  'distill.hero.cta2': 'المنهجية: أربع خطوات',
  'distill.pain.quote.en': 'Absorb what is useful, discard what is useless.',
  'distill.pain.quote.zh': 'اقتبس المفيد وارفض عديم الفائدة — بروس لي عرّف استخلاص المعرفة قبل عقود.',
  'distill.pain.heading': 'أربع طرق تتبخر بها معرفة المؤسسة',
  'distill.pain.c1.tt': 'تقاعد الخبير',
  'distill.pain.c1.ds': 'عشرون عاماً من الحُكم تبدد في حفل وداع — الخبرة لم تغادر رأسه قط.',
  'distill.pain.c2.tt': 'مقبرة محاضر الاجتماعات',
  'distill.pain.c2.ds': 'محفوظة لكن لا أحد يقرأها. الملف الأربعة آلاف مضمر في عمق مجلد مشترك.',
  'distill.pain.c3.tt': 'تكلّس الإجراءات',
  'distill.pain.c3.ds': 'تتجاوز صلاحيتها لحظة كتابتها — الوثائق تتعثر وراء الواقع، والموظف الجديد يتعلم الطريقة الخاطئة.',
  'distill.pain.c4.tt': 'ذكاء اصطناعي مفرّغ',
  'distill.pain.c4.ds': 'بدون معرفتكم، الذكاء الاصطناعي مجرد روبوت محادثة مهذب.',
  'distill.method.quote.en': "It's not the daily increase but daily decrease — hack away at the unessential.",
  'distill.method.quote.zh': 'ليست الزيادة اليومية بل النقصان اليومي — التقطير فن القص؛ حائط القواعد يُنقَر لا يُراكم.',
  'distill.method.heading': 'حلقة التقطير بأربع خطوات',
  'distill.method.s1.tt': 'اعتراض',
  'distill.method.s1.en': '01 / INTERCEPT',
  'distill.method.s1.ds': 'في يوم انتهاء الاجتماع يدخل محضرها المعبأ مباشرة — قبل أن يتبخر.',
  'distill.method.s1.out': 'الناتج: معرفة خام مُقتنصة',
  'distill.method.s2.tt': 'تقطير',
  'distill.method.s2.en': '02 / DISTIL',
  'distill.method.s2.ds': 'الذكاء الاصطناعي والاستشاري يقطّران معاً: الآلة تنقّي، والاستشاري يقصّ غير الجوهري.',
  'distill.method.s2.out': 'الناتج: قواعد مرشّحة',
  'distill.method.s3.tt': 'تبلور',
  'distill.method.s3.en': '03 / CRYSTALLISE',
  'distill.method.s3.ds': 'مراجعة بشرية تُعلّق القواعد على الحائط — كل قاعدة: سياق + إجراء + مسؤول.',
  'distill.method.s3.out': 'الناتج: حائط القواعد',
  'distill.method.s4.tt': 'إعادة توظيف',
  'distill.method.s4.en': '04 / REFLOW',
  'distill.method.s4.ds': 'موظفو الذكاء الاصطناعيعملون بالقواعد، ومراجعة شهرية تزيد دقتها مع الاستخدام.',
  'distill.method.s4.out': 'الناتج: ذاكرة مؤسسية',
  'distill.show.kicker': 'THE DISTILLERY · العرض الرئيسي',
  'distill.show.heading': 'رحلة قطرة معرفة واحدة',
  'distill.show.lead': 'في الأعلى الضجيج الخام الذي يهطل كل يوم؛ الخط الذهبي في المنتصف هو اليد التي تعترضه؛ في الأسفل، القواعد التي تبقى وتعمل.',
  'distill.show.ch1': 'محضر_الاجتماع_v7_النهائي(2).docx',
  'distill.show.ch2': 'الاجتماع المشترك بين الأقسام رقم ٣٨',
  'distill.show.ch3': 'قال إننا نناقش ذلك لاحقاً…',
  'distill.show.ch4': 'مجلد مشترك (٤٢٠٠ ملف)',
  'distill.show.ch5': 'الخبير يتقاعد الشهر القادم',
  'distill.show.ch6': '٢١٧ رسالة متبادلة',
  'distill.show.funnel': 'اعتراض · تقطير · ترسيب',
  'distill.show.rule1.tag': 'قاعدة · الاجتماعات',
  'distill.show.rule1.text': 'كل اجتماع ينتهي بـ«من + يفعل ماذا + متى» — إن نقص أحدها عُقد الاجتماع من جديد.',
  'distill.show.rule2.tag': 'قاعدة · التعامل الخارجي',
  'distill.show.rule2.text': 'كل التزام يُعتمد داخلياً قبل إرساله — لا أحد يتحدث باسم الشركة على عجلة.',
  'distill.show.rule3.tag': 'قاعدة · الوثائق',
  'distill.show.rule3.text': 'تُراجَع إجراءات العمل كل ٩٠ يوماً — الكاتب يوقّع والمعدِّل يترك أثراً.',
  'distill.show.rule4.tag': 'قاعدة · تسليم المهام',
  'distill.show.rule4.text': 'الموظف الجديد يقرأ حائط القواعد خلال ثلاثة أيام ثم يبدأ العمل.',
  'distill.show.note': 'القواعد النموذجية أمثلة عامة وليست من أي مكتبة قواعد فعلية لعملاء',
  'distill.proof.kicker': 'برهان الممارسة',
  'distill.proof.heading': 'نحن لا نعلّمكم التقطير — نحن نقطّر كل يوم',
  'distill.proof.s1.n': '252',
  'distill.proof.s1.l': 'قاعدة عمل تُرسب باستمرار في نظام الحوكمة الذي نستخدمه بأنفسنا',
  'distill.proof.s2.n': 'أسبوعياً',
  'distill.proof.s2.l': 'إيقاع حصاد ومراجعة لا يتوقف',
  'distill.proof.s3.n': '6 لغات',
  'distill.proof.s3.l': 'خبرة حوكمة معرفة عبر الموقع كله، قابلة للنقل مباشرة',
  'distill.proof.quote.en': 'Using no way as way — having no limitation as limitation.',
  'distill.proof.quote.zh': 'بلا منهجية محددة كمنهجية — القواعد تُرسب من الممارسة الفعلية، لا تُنسخ من القوالب.',
  'distill.fit.heading': 'لمن هذه الخدمة',
  'distill.fit.f1.tt': 'المنظمات غير الربحية',
  'distill.fit.f1.ds': 'علاقات المانحين وخبرة المتطوعين لم تعد تضيع مع كل تبديل للكوادر.',
  'distill.fit.f2.tt': 'المؤسسات الاجتماعية',
  'distill.fit.f2.ds': 'خبرة الرسالة والتشغيل تُورَّث دون تشوه عند التوسع.',
  'distill.fit.f3.tt': 'الشركات الصغيرة والمتوسطة',
  'distill.fit.f3.ds': 'حوّل حُكم صاحب المؤسسة إلى نظام تستخدمه الشركة بأكملها.',
  'distill.fit.f4.tt': 'الشركات الكبرى',
  'distill.fit.f4.ds': 'حوكمة معرفة عابرة للأقسام: الخبرة الضمنية لكل فريق تصبح قواعد قابلة للتنفيذ لموظفي الذكاء الاصطناعي.',
  'distill.faq.q1': 'كم يستغرق التقطير؟',
  'distill.faq.a1': 'الجولة الأولى هدفها التسليم في اليوم نفسه: في يوم انتهاء الاجتماع تكون قواعده على الحائط. تتقدم الحلقة الكاملة — اعتراض، تقطير، تبلور، إعادة توظيف — أسبوعياً بحسب حجم المؤسسة، ثم تستمر بدوريات شهرية.',
  'distill.faq.q2': 'هل ستتسرب معرفتنا؟',
  'distill.faq.a2': 'لا. القواعد المنتجة ملك لكم وتُخزَّن ضمن نطاق سلطتكم؛ نعمل عليها فقط خلال فترة الخدمة بتصريحكم، وننسحب بعد التسليم.',
  'distill.faq.q3': 'ما الفرق بين هذا وأدوات إدارة المعرفة بالذكاء الاصطناعي؟',
  'distill.faq.a3': 'الأدوات تخزّن فقط، أما التقطير فيقصّ ويشكّل. بدون بنية القاعدة «من + يفعل ماذا + متى» تبقى البيانات مهما كثرت غير قابلة للتنفيذ — نحن نسلّم قدرة على الحكم، لا قاعدة بيانات.',
  'distill.faq.q4': 'كيف تتصل القواعد المقطَّرة بموظفي الذكاء الاصطناعي؟',
  'distill.faq.a4': 'حائط القواعد هو مرجع عمل موظف الذكاء الاصطناعي: مدير المشاريع الآلي يعمل بالقواعد ويعتمد داخلياً بها، والمراجعة الشهرية تعيد ضخ خبرات جديدة كقواعد جديدة — حلقة مغلقة.',
  'distill.faq.q5': 'هل يختلف النهج بين الشركات الكبرى والصغيرة والمتوسطة؟',
  'distill.faq.a5': 'الشركات الصغيرة والمتوسطة تركز على مؤسسنة حُكم المالك؛ الكبرى تحتاج حوكمة عابرة للأقسام — خبرة كل فريق الضمنية تُوحَّد في مجموعات قواعد متوافقة وقابلة للتنفيذ.',
  'distill.faq.q6': 'كيف نبدأ؟',
  'distill.faq.a6': 'نبدأ بتشخيص لمدة ٣٠ دقيقة: جرد أثمن أصول المعرفة في مؤسستكم — وأكثرها خطورة (المتبخرة) — ثم تحديد نطاق التقطير وإيقاعه.',
  'distill.funnel.heading': 'من قطرة ضجيج إلى فريق من موظفي الذكاء الاصطناعي',
  'distill.funnel.f1.tag': 'الخطوة ١',
  'distill.funnel.f1.tt': 'التشخيص',
  'distill.funnel.f1.ds': 'جرد في ٣٠ دقيقة لأثمن أصول المعرفة في مؤسستكم — وأكثرها خطورة (المتبخرة).',
  'distill.funnel.f2.tag': 'الخطوة ٢ · هذه الصفحة',
  'distill.funnel.f2.tt': 'تقطير المعرفة',
  'distill.funnel.f2.ds': 'حلقة الخطوات الأربع تُعلّق القواعد على الحائط — للمعرفة شكل أخيراً.',
  'distill.funnel.f3.tag': 'الخطوة ٣',
  'distill.funnel.f3.tt': 'إدارة موظفي الذكاء الاصطناعي',
  'distill.funnel.f3.ds': 'مديرو مشاريع آليون في الموقع يعملون من حائط قواعدكم — نحن نبيع موظفين، لا برمجيات.',
  'distill.cta1': 'تحدث عبر واتساب',
  'distill.cta2': 'عن التشخيص',
  'distill.wa.text': 'مرحباً! أريد التعرف على خدمة معمل تقطير المعرفة من JKD Coding.',
  'distill.footer': 'JKD Coding · Using no way as way',
  'distill.card.title': 'استخلاص المعرفة',
  'distill.card.desc': 'قطّر الخبرة المتناثرة في الاجتماعات وعقول الزملاء المخضرمين إلى قواعد قابلة للتنفيذ يعمل بها موظفو الذكاء الاصطناعي.',
  'distill.card.cta': 'ادخل معمل التقطير',
  'distill.xs.title': 'بعد التشخيص: قطّر النتائج إلى قواعد',
  'distill.xs.body': 'التشخيص يجد عنق الزجاجة، ومعمل تقطير المعرفة يحوّل خبرة المؤسسة إلى قواعد قابلة للتنفيذ وإعادة الاستخدام يعمل بها موظفو الذكاء الاصطناعي — لحظة انتهاء الاجتماع تكون القواعد على الحائط.',
  'distill.xs.cta': 'ادخل معمل التقطير',

  // ============ الشروط والأحكام /terms (ثلاث تبويبات: الخصوصية / الاسترداد / التسليم) ============
  'terms.meta.title': 'الشروط والأحكام — سياسة الخصوصية والاسترداد والتسليم | JKD Coding',
  'terms.meta.description': 'الشروط والأحكام لـ JKD Coding (تديرها Wiseman Consultancy Limited): سياسة الخصوصية وسياسة الاسترداد وسياسة التسليم، وتنطبق على هذا الموقع وجميع خدمات الاستشارة والتطوير الرقمي.',
  'terms.title': 'الشروط والأحكام',
  'terms.subtitle': 'تنطبق هذه الشروط على موقع JKD Coding (jkdcoding.com) وجميع خدمات الاستشارة والخدمات الرقمية التي نقدمها. يُدار الموقع والخدمات من قبل Wiseman Consultancy Limited.',
  'terms.updated': 'آخر تحديث: 2026-10-13',
  'terms.tab.privacy': 'سياسة الخصوصية',
  'terms.tab.refund': 'سياسة الاسترداد',
  'terms.tab.delivery': 'سياسة التسليم',
  'terms.contact': 'إذا كانت لديك أي أسئلة، تواصل معنا عبر واتساب +852 5165 1480.',

  // — سياسة الخصوصية —
  'terms.privacy.note': 'توضح هذه السياسة كيف تجمع JKD Coding (تديرها **Wiseman Consultancy Limited**) بياناتك وتستخدمها وتحميها. باستخدامك هذا الموقع أو خدماتنا فإنك توافق على شروط هذه السياسة.',
  'terms.privacy.h1': '1. البيانات التي نجمعها',
  'terms.privacy.s1': '- **بيانات الاستفسار والتواصل**: الاسم، رقم واتساب، البريد الإلكتروني، الجهة (عبر حجز التشخيص أو واتساب أو النماذج)\n- **بيانات المشروع**: مواد العمل ومحتوى قاعدة المعرفة وأصول الموقع التي تقدمها\n- **بيانات التصفح**: مشاهدات الصفحات، المصدر المحيل، ومعاملات التسويق (إحصاءات مجهولة لتحسين الموقع وأداء الإعلانات)\n- **بيانات الدفع**: نحتفظ فقط برقم الفاتورة والمبلغ، و**لا نطّلع أبداً على بيانات وسيلة الدفع الخاصة بك ولا نخزّنها**',
  'terms.privacy.h2': '2. كيف نستخدم البيانات',
  'terms.privacy.s2': '- تقديم خدماتنا الاستشارية والتطويرية وتشغيلها وتحسينها\n- عروض الأسعار وإدارة المشاريع والدعم الفني والفوترة\n- إشعارات الخدمة الأساسية (تأكيد الحجوزات، ترتيبات التسليم، تنبيهات الأمان)',
  'terms.privacy.h3': '3. المعالجة عبر أطراف ثالثة (محرك الذكاء الاصطناعي)',
  'terms.privacy.s3': 'لتقديم الخدمات المتعلقة بالذكاء الاصطناعي، قد يُرسل المحتوى الذي تقدمه إلى مزودي نماذج اللغة الكبيرة الذين نستخدمهم (بما فيهم DeepSeek وZ.ai وغيرهما)، ويعالج هؤلاء البيانات بموجب سياسات الخصوصية الخاصة بهم. نرسل فقط المحتوى اللازم لإتمام العمل، ونراجع باستمرار ترتيباتهم لحماية البيانات.',
  'terms.privacy.h4': '4. الاحتفاظ بالبيانات',
  'terms.privacy.s4': '- سجلات الاستفسار والمحادثات: تُحفظ لمدة 24 شهراً تقريباً ثم تُمسح\n- ملفات المشروع: تُحفظ 90 يوماً بعد التسليم للإصلاحات والدعم، ثم تُحذف عند الطلب أو تُمسح تلقائياً',
  'terms.privacy.h5': '5. ما لافعله أبداً',
  'terms.privacy.s5': '- لا نبيع بياناتك ولا نؤجرها\n- لا نستخدم بياناتك — أو بيانات عملائك — للتسويق مع أطراف ثالثة\n- لا نفصح عن البيانات لأي طرف ثالث إلا إذا طلب القانون ذلك أو كان ضرورياً لتقديم الخدمة (مثل محركات الذكاء الاصطناعي ومزودي الاستضافة والدفع)',
  'terms.privacy.h6': '6. حقوقك',
  'terms.privacy.s6': 'يحق لك الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها. أرسل طلبك عبر واتساب +852 5165 1480؛ ونرد خلال **14 يوماً**. نتعامل مع البيانات الشخصية وفق مرسوم البيانات الشخصية (الخصوصية) (الفصل 486، قوانين هونغ كونغ).',
  'terms.privacy.h7': '7. تحديث السياسة',
  'terms.privacy.s7': 'ستُنشر التغييرات الجوهرية على هذه الصفحة مع تحديث التاريخ. أما التغييرات التي تؤثر جوهرياً على استخدام الخدمة فسيُبلَّغ عنها على حدة.',

  // — سياسة الاسترداد —
  'terms.refund.note': 'تقدم JKD Coding خدمات استشارية وتطويراً رقمياً (لا سلعاً مادية). جميع الأسعار بالدولار الهونغ كونغي. نشجعك على حجز **التشخيص المجاني** (30 دقيقة وجهاً لوجه) أولاً وأن تقرر بوضوح قبل الدفع.',
  'terms.refund.h1': '1. التشخيص المجاني',
  'terms.refund.s1': 'التشخيص مجاني تماماً وبلا ضغط بيعي. جميع الأعمال المدفوعة تُسعَّر بعد التشخيص ولا تبدأ إلا بعد تأكيدك الكتابي.',
  'terms.refund.h2': '2. الإلغاء قبل بدء العمل',
  'terms.refund.s2': 'إذا ألغيت بعد التأكيد وقبل بدء العمل: تُسترد جميع المدفوعات **كاملة**. وتُخصم التكاليف التي تكبّرناها نيابة عنك من أطراف ثالثة (النطاق، التراخيص، موارد الحوسبة السحابية وغيرها) بالتكلفة الفعلية مع إيصالات.',
  'terms.refund.h3': '3. الخطط الجاهزة ومكتبة المكونات',
  'terms.refund.s3': 'خلال **7 أيام** من الدفع، إذا تعذر تسليم الخدمة أو تشغيلها بسببنا ولم نتمكن من إصلاحها في وقت معقول، يمكنك طلب **استرداد كامل**. وبعد التسليم الناجح والتشغيل الطبيعي تُعد الخدمة مكتملة وغير قابلة للاسترداد.',
  'terms.refund.h4': '4. المشاريع المخصصة (نظام المراحل)',
  'terms.refund.s4': '- تُفوتر المشاريع المخصصة حسب المراحل: **المراحل التي بدأت** تُسوّى وفق التقدم الفعلي المنجز، و**المراحل التي لم تبدأ** قابلة للاسترداد\n- الإلغاء في منتصف الطريق: الأعمال المكتملة والمقبولة غير قابلة للاسترداد، ويُسترد الباقي بالتناسب\n- طلبات التعديل بعد التسليم تُعد نطاقاً جديداً وتُسعَّر على حدة',
  'terms.refund.h5': '5. أخطاء الفوترة',
  'terms.refund.s5': 'الرسوم المكررة أو الخاطئة، بعد التحقق منها، تُسترد بالكامل إلى وسيلة الدفع الأصلية خلال **7 أيام عمل**.',
  'terms.refund.h6': '6. كيفية التقديم',
  'terms.refund.s6': 'واتساب +852 5165 1480 (يرجى تقديم رقم الفاتورة). تُعالج جميع الطلبات خلال **7 أيام عمل**؛ ويُعاد المبلغ عبر قناة الدفع الأصلية.',

  // — سياسة التسليم —
  'terms.delivery.note': 'تقدم JKD Coding خدمات رقمية بحتة — **لا شحن مادي**. جميع التسليمات إلكترونية ولا تُفرض رسوم شحن.',
  'terms.delivery.h1': '1. مهلة التسليم',
  'terms.delivery.s1': '- **الخطط الجاهزة**: التنفيذ خلال 30 دقيقة كحد أدنى بعد تأكيد المتطلبات واستلام الدفع (ساعات العمل)\n- **مكتبة المكونات**: تُرسل التراخيص والوثائق بالبريد الإلكتروني/واتساب خلال يوم عمل من الدفع\n- **المشاريع المخصصة**: تُسلَّم وفق مراحل العقد، وتُطلق عادة خلال 6–8 أسابيع\n- تُعالج الطلبات خارج ساعات العمل في جلسة العمل التالية؛ ويُجاب على جميع الاستفسارات خلال 24 ساعة',
  'terms.delivery.h2': '2. ما يُسلَّم',
  'terms.delivery.s2': 'حسب الخطة، يشمل التسليم عادة: صلاحية الوصول إلى الموقع/النظام، الشيفرة المصدرية أو بيئة النشر، أدلة الإعداد والاستخدام، وقناة الدعم الفني.',
  'terms.delivery.h3': '3. طريقة التسليم',
  'terms.delivery.s3': 'كل شيء يُسلَّم إلكترونياً (الويب، البريد الإلكتروني، واتساب). وبعد إتمام النشر وموافقة الطرفين على العمل تُعد الخدمة قد سُلِّمت وبدأت.',
  'terms.delivery.h4': '4. تأخير التسليم',
  'terms.delivery.s4': 'إذا تجاوز التسليم المهلة الموعودة، يمكنك اختيار **إعادة التسليم الفوري** أو طلب الاسترداد بموجب [سياسة الاسترداد](#refund).',

  // — رابط الشروط في التذييل —
  'footer.termsLink': 'الشروط والأحكام',
};

export default dict;
